import React from 'react';

import PropTypes from 'prop-types';

// Components
import { Mui, MuiLab, TextField } from 'components';

function OptionsMultiSelectFilter({
  label,
  limitTags = 2,
  options,
  selectedValue,
  onSelect,
  ...otherProps
}) {
  const selectedValues = React.useMemo(() => {
    const selectedValueSet = new Set(selectedValue?.split(',') || []);
    return options.filter(option => selectedValueSet.has(option.value));
  }, [options, selectedValue]);

  const handleChange = (event, selectedOption) => {
    onSelect(selectedOption?.length ? selectedOption.map(option => option.value).join(',') : null);
  };

  return (
    <MuiLab.Autocomplete
      multiple
      options={options}
      limitTags={limitTags}
      value={selectedValues}
      getOptionLabel={option => option?.label || ''}
      getOptionSelected={(option, value) => option?.value === value?.value}
      onChange={handleChange}
      renderOption={(option, { selected }) => (
        <Mui.Grid container spacing={1} wrap="nowrap" alignItems="center">
          <Mui.Grid item>
            <Mui.Checkbox checked={selected} />
          </Mui.Grid>
          <Mui.Grid item xs>
            {option?.label}
          </Mui.Grid>
        </Mui.Grid>
      )}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => <Mui.Chip label={option?.label} {...getTagProps({ index })} />)
      }
      renderInput={inputParams => <TextField {...inputParams} label={label} margin="none" />}
      {...otherProps}
    />
  );
}

OptionsMultiSelectFilter.propTypes = {
  label: PropTypes.string,
  limitTags: PropTypes.number,
  options: PropTypes.array,
  selectedValue: PropTypes.string,
  onSelect: PropTypes.func,
};

export default OptionsMultiSelectFilter;
